module.exports = __webpack_public_path__ + "img/ai-5.517b3bf.png";